export abstract class HashableEntity {
  public plain: string = "";
  public hashed: string = "";
}
